import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { WfLink } from "src/components/base/wf-link";
import { IconAvatar, IconWikifolio } from "src/components/icons";

interface IMentionReplacementProps {
    portfolioText: string;
    link: string;
    traderName: string;
    performance: string;
}

export const MentionReplacement = ({ portfolioText, link, traderName, performance }: IMentionReplacementProps) => (
    <>
        {`(${portfolioText}`}{" "}
        <Box as="span" whiteSpace="nowrap">
            <IconAvatar boxSize={2} position="relative" display="inline-block" bottom="2px" />{" "}
            <WfLink href={link} fontWeight="bold" fontSize="md" whiteSpace="normal">
                {traderName}
            </WfLink>
        </Box>{" "}
        <Box as="span" backgroundColor="green.50" borderRadius="16px" px={0.5} display="inline-flex" verticalAlign="middle" whiteSpace="nowrap">
            <IconWikifolio color="green.500" boxSize={2} alignSelf="center" mr={0.5} />
            <Text as="span" fontSize="sm">
                {performance}
            </Text>
        </Box>
        {")"}
    </>
);
